import React from 'react'
import intl from 'react-intl-universal'
import styled, { css } from 'styled-components'
import { Swiper, Text, LargeWrapper } from '@raysync/common/components'
import { useMedia, useHover } from '@raysync/common/hooks'

import ImgEn1 from './1.png'
import ImgEn2 from './2.png'
import ImgEn3 from './3.png'
import ImgEn4 from './4.png'
import ImgEn5 from './5.png'
import ImgEn6 from './6.png'
import ImgEn7 from './7.png'
import ImgEn8 from './8.png'
import ImgEn9 from './9.png'
import ImgEn10 from './10.png'

const FeatureContainer = styled.div`
  display: flex;
  justify-content: space-between;
  img {
    width: 670px;
    height: 326px;
  }
`

const MainItemShadow = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  box-shadow: 0px 0px 30px 0px #e2e7ec;
`
const MainItem = styled.div`
  width: 660px;
  position: relative;
  background: ${p => (p.active ? '#fff' : p.theme.color.panel)};
  min-height: 60px;
  display: flex;
  align-items: center;
  border-radius: 10px;
  margin-bottom: 4px;
  /* box-shadow: ${p => (p.active ? '0px 0px 30px 0px #e2e7ec' : 'unset')}; */
  p {
    padding-left: 16px;
    font-size: 18px;
    color: #636772;
    line-height: 24px;
  }
`
const MobileWrapper = styled.div`
  ${Text} {
    padding-top: 0.8rem;
    padding-bottom: 0.3rem;
  }
`
const MobileMainItem = styled.div`
  ${({ theme: { color } }) => css`
    padding: 0.4rem 0.3rem 0.3rem;
    margin-bottom: 0.2rem;
    min-height: 6rem;
    background: white;
    box-shadow: 0px 0px 6px 0px rgba(226, 231, 236, 1);
    border-radius: 10px;
    img {
      display: block;
      margin: 0 auto 0.5rem;
      width: 100%;
      height: 4rem;
    }
    p {
      font-size: 0.3rem;
    }
  `}
`
const FuncItem = ({ onTrigger, children, active }) => {
  const ref = React.useRef()
  useHover(ref, onTrigger, true)
  return (
    <MainItem ref={ref} active={active}>
      {children}
      {active && <MainItemShadow active={active} />}
    </MainItem>
  )
}
const Feature = () => {
  const userList = [
    {
      title: intl.get('solution8.solution.app.desc1'),
      img: ImgEn1,
    },
    {
      title: intl.get('solution8.solution.app.desc2'),
      img: ImgEn2,
    },
    {
      title: intl.get('solution8.solution.app.desc3'),
      img: ImgEn3,
    },
    {
      title: intl.get('solution8.solution.app.desc4'),
      img: ImgEn4,
    },
    {
      title: intl.get('solution8.solution.app.desc5'),
      img: ImgEn5,
    },
  ]
  const adminList = [
    {
      title: intl.get('solution8.solution.admin.desc1'),
      img: ImgEn6,
    },
    {
      title: intl.get('solution8.solution.admin.desc2'),
      img: ImgEn7,
    },
    {
      title: intl.get('solution8.solution.admin.desc3'),
      img: ImgEn8,
    },
    {
      title: intl.get('solution8.solution.admin.desc4'),
      img: ImgEn9,
    },
    {
      title: intl.get('solution8.solution.admin.desc5'),
      img: ImgEn10,
    },
  ]
  const [userActived, setUserActived] = React.useState(0)
  const [adminActived, setAdminActived] = React.useState(0)

  const isMobile = useMedia()

  if (isMobile) {
    return (
      <MobileWrapper>
        <Text bottom={25} top={80}>
          {intl.get('solution8.solution.app.title')}
        </Text>
        <Swiper swiperNavType='touch'>
          {userList.map((l, i) => (
            <MobileMainItem key={i}>
              <img src={l.img} alt={l.title} />
              <p>{l.title}</p>
            </MobileMainItem>
          ))}
        </Swiper>
        <Text bottom={25} top={80}>
          {intl.get('solution8.solution.admin.title')}
        </Text>
        <Swiper swiperNavType='touch'>
          {adminList.map((l, i) => (
            <MobileMainItem key={i}>
              <img src={l.img} alt={l.title} />
              <p>{l.title}</p>
            </MobileMainItem>
          ))}
        </Swiper>
      </MobileWrapper>
    )
  }

  return (
    <LargeWrapper>
      <Text bottom={25} top={80}>
        {intl.get('solution8.solution.app.title')}
      </Text>
      <FeatureContainer>
        <div>
          {userList.map((l, i) => (
            <FuncItem
              key={i}
              active={userActived === i}
              onTrigger={() => {
                setUserActived(i)
              }}
            >
              <p>{l.title}</p>
            </FuncItem>
          ))}
        </div>
        <img src={userList[userActived].img} alt='user-end' />
      </FeatureContainer>
      <Text top={70} bottom={30} left={740}>
        {intl.get('solution8.solution.admin.title')}
      </Text>
      <FeatureContainer style={{ flexDirection: 'row-reverse' }}>
        <div>
          {adminList.map((l, i) => (
            <FuncItem
              key={i}
              active={adminActived === i}
              onTrigger={() => {
                setAdminActived(i)
              }}
            >
              <p>{l.title}</p>
            </FuncItem>
          ))}
        </div>
        <img src={adminList[adminActived].img} alt='admin-end' />
      </FeatureContainer>
    </LargeWrapper>
  )
}

export default Feature
